import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exdeals',
  templateUrl: './exdeals.component.html',
  styleUrls: ['./exdeals.component.css']
})
export class ExdealsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
